// Session persistence. "Remember me" decides where the JWT + user live:
// localStorage survives a browser restart; sessionStorage clears with the tab.
import { STORAGE_KEYS } from '@/utils/constants'

const KEYS = [STORAGE_KEYS.TOKEN, STORAGE_KEYS.USER, STORAGE_KEYS.PERMISSIONS]

// localStorage wins so a "remembered" session is preferred over a stale tab one.
function read(key) {
  return localStorage.getItem(key) ?? sessionStorage.getItem(key)
}

export function getToken() {
  return read(STORAGE_KEYS.TOKEN) || null
}

export function getUser() {
  return JSON.parse(read(STORAGE_KEYS.USER) || 'null')
}

// True when the active session is in localStorage (i.e. "remember me" was set).
export function isPersistent() {
  return localStorage.getItem(STORAGE_KEYS.TOKEN) !== null
}

export function persistSession(token, user, remember) {
  clearSession()
  const store = remember ? localStorage : sessionStorage
  store.setItem(STORAGE_KEYS.TOKEN, token || '')
  store.setItem(STORAGE_KEYS.USER, JSON.stringify(user ?? null))
}

// Write the user back to whichever store currently holds the session.
export function persistUser(user) {
  const store = isPersistent() ? localStorage : sessionStorage
  store.setItem(STORAGE_KEYS.USER, JSON.stringify(user ?? null))
}

export function clearSession() {
  KEYS.forEach((key) => {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  })
}
